<template>
  <div class="checkbox-quantity-wrap">
    <CheckboxButton :label="inputValue.product.name"
                    v-model="isChecked"
                    @input="handleCheckboxChange" />

    <VItemCounter v-if="isChecked"
                  :max="limit"
                  size="small"
                  :value="quantity"
                  @update:value="updateQuantity" />
  </div>
</template>

<script>
import CheckboxButton from '@/components/CheckboxButton.vue';
import VItemCounter from "@/components/ui/VItemCounter.vue";

export default {
  name: "CheckboxWithQuantity",
  components: {
    CheckboxButton,
    VItemCounter,
  },
  props: {
    inputValue: {
      type: Object,
      required: true,
    },
    value: {
      type: Array,
      default: () => [],
    },
    limit: {
      type: Number,
      default: 5,
    },
  },
  data() {
    return {
      isChecked: false,
      quantity: 1,
    };
  },
  methods: {
    handleCheckboxChange() {
      if (this.isChecked) {
        this.$emit('input', [...this.value, { ...this.inputValue, quantity: this.quantity }]);
      } else {
        this.$emit('input', this.value.filter(item => item.id !== this.inputValue.id));
      }
    },
    updateQuantity(val) {
      this.quantity = val;

      this.$emit('input', this.value.map(item =>
        item.id === this.inputValue.id ? { ...item, quantity: this.quantity } : item
      ));
    },
  },
};
</script>

<style lang="scss" scoped>
.checkbox-quantity-wrap {
  display: grid;
  gap: 12px;
  justify-items: start;
}
</style>